import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Student } from 'src/app/classes/model/student';
import { NotifierService } from 'src/app/services/common/notifier-service.service';
import { StudentNotificationService, SendPushNotificationRequest } from 'src/app/services/student-notification.service';

@Component({
  selector: 'app-send-push-notification-dialog',
  templateUrl: './send-push-notification-dialog.component.html',
  styleUrls: ['./send-push-notification-dialog.component.scss']
})
export class SendPushNotificationDialogComponent implements OnInit {
  notificationFG: FormGroup;
  identifierTypeFC: FormControl;
  identifierValueFC: FormControl;
  titleFC: FormControl;
  bodyFC: FormControl;

  isSending: boolean = false;

  identifierTypes = [
    { value: 'uuid', label: 'UUID' },
    { value: 'email', label: 'E-mail' }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SendPushNotificationDialogData,
    private dialogRef: MatDialogRef<SendPushNotificationDialogComponent>,
    private studentNotificationService: StudentNotificationService,
    private notifierService: NotifierService
  ) { }

  ngOnInit(): void {
    // Initialize with student data if provided
    const initialIdentifierType = this.data.student?.uuid ? 'uuid' : 'email';
    const initialIdentifierValue = this.data.student?.uuid || this.data.student?.email || '';

    this.identifierTypeFC = new FormControl(initialIdentifierType);
    this.identifierValueFC = new FormControl(initialIdentifierValue, [Validators.required]);
    this.titleFC = new FormControl('', [Validators.required]);
    this.bodyFC = new FormControl('', [Validators.required]);

    this.notificationFG = new FormGroup({
      identifierTypeFC: this.identifierTypeFC,
      identifierValueFC: this.identifierValueFC,
      titleFC: this.titleFC,
      bodyFC: this.bodyFC
    });
  }

  public async handleSendButtonClick(): Promise<void> {
    if (this.notificationFG.invalid || this.isSending) {
      return;
    }

    this.isSending = true;

    try {
      const request: SendPushNotificationRequest = {
        title: this.titleFC.value,
        body: this.bodyFC.value
      };

      // Set the appropriate identifier based on the selected type
      if (this.identifierTypeFC.value === 'uuid') {
        request.studentUuid = this.identifierValueFC.value;
      } else {
        request.studentEmail = this.identifierValueFC.value;
      }

      const response = await this.studentNotificationService.sendPushNotification(request);

      if (response.atLeastOneSuccessful) {
        this.notifierService.notify('success', 'Értesítés sikeresen elküldve!');
        this.dialogRef.close(true);
      } else {
        this.notifierService.notify('warning', 'Az értesítés nem ért el egyetlen eszközt sem.');
      }
    } catch (error: any) {
      // Error is already handled by the service
    } finally {
      this.isSending = false;
    }
  }

  public getIdentifierPlaceholder(): string {
    return this.identifierTypeFC.value === 'uuid' ? 'pl. abc123-def456...' : 'pl. example@email.com';
  }

  public getIdentifierLabel(): string {
    return this.identifierTypeFC.value === 'uuid' ? 'Tanuló UUID' : 'Tanuló e-mail';
  }
}

export interface SendPushNotificationDialogData {
  student?: Student;
}
